export function RemoveDateFromFileName(fileName) {
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex === -1) {
    return fileName;
  }

  const baseName = fileName.slice(0, dotIndex);
  const extension = fileName.slice(dotIndex);

  const underscoreIndex = baseName.lastIndexOf("_");
  if (underscoreIndex !== -1) {
    const possibleDate = baseName.slice(underscoreIndex + 1);
    if (/^\d{8}$/.test(possibleDate)) {
      return baseName.slice(0, underscoreIndex) + extension;
    }
  }

  return fileName;
}
